import http from "../js/axios";

// Phase 2 - US-013: Fee Structure Service
class FeeService {
  // Fee Master - List all fees
  getFeeMaster() {
    return http.post("/fee/master", { dml_indicator: "L" });
  }

  // Fee Master - Update fee amount
  updateFeeMaster(data) {
    data.dml_indicator = "U";
    return http.post("/fee/master", data);
  }

  // Fee Master - Calculate fee for a given type/organ
  calculateFee(data) {
    data.dml_indicator = "CALC";
    return http.post("/fee/master", data);
  }

  // Fee Waiver - Apply new waiver
  applyWaiver(data) {
    data.dml_indicator = "C";
    return http.post("/fee/waiver", data);
  }

  // Fee Waiver - List waivers (by hospital)
  getWaivers(hospital_id) {
    return http.post("/fee/waiver", {
      dml_indicator: "L",
      hospital_id,
    });
  }

  // Fee Waiver - Approve/Reject waiver
  updateWaiverStatus(waiver_id, status) {
    return http.post("/fee/waiver", {
      dml_indicator: "A",
      waiver_id,
      status,
    });
  }

  // Fee Report - Get fee collection report
  getFeeReport(date_from, date_to) {
    return http.post("/fee/report", { date_from, date_to });
  }
}

export default new FeeService();
